module.exports = __webpack_public_path__ + "Roboto-Thin.954bbdeb86483e4ffea0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Thin.woff2
// module id = 312
// module chunks = 2